import { render, staticRenderFns } from "./studentSpecialtySelect.vue?vue&type=template&id=110b3502&scoped=true&"
import script from "./studentSpecialtySelect.vue?vue&type=script&lang=js&"
export * from "./studentSpecialtySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110b3502",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
